import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/utilization";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { GROUP_OPTIONS } from "../constants";

export const AverageGroupFilter = () => {
  const dispatch = useDispatch();

  const averageGroup = useSelector((state) => state.utilization.averageGroup);

  return (
    <div className="select-box" style={{ width: "150px" }}>
      <p className="offers-title">Group (Average)</p>
      <MultiSelectDropdown
        options={GROUP_OPTIONS}
        selectedFilters={averageGroup}
        numberDisplayed={0}
        onSelectChange={(data) => dispatch(actionCreators.setAverageGroup(data))}
      />
    </div>
  );
};
